// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3o3WU","fileBtn":"File_fileBtn__2MG32","closeBtn":"File_closeBtn__1aquw","fileSelected":"File_fileSelected__K-QZ7","disabled":"File_disabled__Bu5k7"};